import { compact, get, has, head, isEqual, isNull, omit, isUndefined } from 'lodash-es'
import AIMEOS_GETTER_TYPES from '@/js/plugins/store/modules/aimeos/getter-types'

import API_CONSTANTS from '@/js/helper/api-constants.js'
import {
  PATHS as CUSTOMER_ADDRESS_PATHS,
  CONSTANTS as CUSTOMER_ADDRESS_CONSTANTS,
} from '@/js/helper/aimeos-customer-address-constants.js'
import { BACKORDER_ITEM_FIELD_MAPPING as BACKORDER_CONSTANTS } from '@/js/components/Account/Backorders/components/shared/BackorderListConstants.js'

export const hasAddressRequiredAttributes = basketAddress => {
  return API_CONSTANTS.AIMEOS.BASKET_ADDRESS.REQUIRED.every(key => {
    return has(basketAddress, [
      API_CONSTANTS.ATTRIBUTES,
      API_CONSTANTS.AIMEOS.BASKET_ADDRESS.ATTRIBUTE[key],
    ])
  })
}

export const missingAddressRequiredAttributes = basketAddress => {
  return API_CONSTANTS.AIMEOS.BASKET_ADDRESS.REQUIRED.filter(key => {
    return !has(basketAddress, [
      API_CONSTANTS.ATTRIBUTES,
      API_CONSTANTS.AIMEOS.BASKET_ADDRESS.ATTRIBUTE[key],
    ])
  })
}

const addressAttributeCompareCleanup = object => {
  return Object.entries(object).reduce((acc, [key, value]) => {
    if (value !== '' && !isNull(value)) {
      acc[key] = value
    }
    return acc
  }, {})
}

export const addressAttributeCompare = (address1, address2) => {
  const omittedKeys = ['order.base.address.type', 'nostore']
  const attributes1 = addressAttributeCompareCleanup(
    omit(get(address1, API_CONSTANTS.ATTRIBUTES, {}), omittedKeys),
  )
  const attributes2 = addressAttributeCompareCleanup(
    omit(get(address2, API_CONSTANTS.ATTRIBUTES, {}), omittedKeys),
  )
  return isEqual(attributes1, attributes2)
}

export const basketAddressCompare = ({ getters, billingAddress, deliveryAddress }) => {
  return (
    (isUndefined(billingAddress) ||
      (getters[AIMEOS_GETTER_TYPES.BASKET_PAYMENT_ADDRESS_INCLUDED].length === 1 &&
        addressAttributeCompare(
          billingAddress,
          head(getters[AIMEOS_GETTER_TYPES.BASKET_PAYMENT_ADDRESS_INCLUDED]),
        ))) &&
    (isUndefined(deliveryAddress) ||
      (getters[AIMEOS_GETTER_TYPES.BASKET_DELIVERY_ADDRESS_INCLUDED].length === 1 &&
        addressAttributeCompare(
          deliveryAddress,
          head(getters[AIMEOS_GETTER_TYPES.BASKET_DELIVERY_ADDRESS_INCLUDED]),
        )))
  )
}

export const formatDeliveryAddress = (address, contactAdressId) => {
  const formatted = compact([
    get(address, CUSTOMER_ADDRESS_PATHS.COMPANY),
    get(address, CUSTOMER_ADDRESS_PATHS.ADDRESS1),
    get(address, CUSTOMER_ADDRESS_PATHS.ADDRESS2),
    get(address, CUSTOMER_ADDRESS_PATHS.ADDRESS3),
    compact([
      get(address, CUSTOMER_ADDRESS_PATHS.POSTAL),
      get(address, CUSTOMER_ADDRESS_PATHS.CITY),
    ]).join(' '),
    get(address, CUSTOMER_ADDRESS_PATHS.COUNTRYID),
    get(address, CUSTOMER_ADDRESS_PATHS.EMAIL),
  ])
  const id = get(address, API_CONSTANTS.ID)
  return {
    id,
    hasContactId: contactAdressId ? contactAdressId === id : false,
    [CUSTOMER_ADDRESS_CONSTANTS.ATTRIBUTE.SAP_ADDRESS_ID]: get(
      address,
      CUSTOMER_ADDRESS_PATHS.SAP_ADDRESS_ID,
    ),
    formatted,
  }
}

export const getBackorderAddressValues = address => ({
  [BACKORDER_CONSTANTS.ADDRESS_ID]: get(address, CUSTOMER_ADDRESS_PATHS.SAP_ADDRESS_ID),
  [BACKORDER_CONSTANTS.ADDRESS_NAME]: get(address, CUSTOMER_ADDRESS_PATHS.COMPANY),
  [BACKORDER_CONSTANTS.STREET]: get(address, CUSTOMER_ADDRESS_PATHS.ADDRESS1),
  [BACKORDER_CONSTANTS.ZIP]: get(address, CUSTOMER_ADDRESS_PATHS.POSTAL),
  [BACKORDER_CONSTANTS.CITY]: get(address, CUSTOMER_ADDRESS_PATHS.CITY),
})
